// removed by extract-text-webpack-plugin
module.exports = {"columnContent":"_30wCG5QKSQHcamkI8vApCs"};


/*****************
 ** WEBPACK FOOTER
 ** ./works/meditech-senze/index.module.scss
 ** module id = 1794
 ** module chunks = 0
 **/